import React, { useState, useEffect } from "react";
import {
  Box,
  Button,
  Center,
  CloseButton,
  Flex,
  FormControl,
  FormLabel,
  Heading,
  Input,
  Radio,
  RadioGroup,
  Select,
  Stack,
  Text,
  Textarea,
  useRadio,
  useRadioGroup,
} from "@chakra-ui/react";
import { useLocation, useNavigate } from "react-router-dom";
import Badge_Component from "../../../Components/Recruiter/Badge/Badge_Component";
import Navbar from "../../../Components/Recruiter/Navbar/Navbar";
import * as api from "../../../services/api";
import moment from "moment";
import roboto from "@fontsource/roboto";
import epilogue from "@fontsource/epilogue";
import { useDispatch } from "react-redux";
import { filterActions } from "../../../redux/actions";
import swAlert from "sweetalert2";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
const CustomRadio = (props) => {
  const { text, ...radioProps } = props;
  const { state, getInputProps, getCheckboxProps, htmlProps, getLabelProps } =
    useRadio(radioProps);
  return (
    <Box as="label">
      <input {...getInputProps({})} />
      <Box
        {...getCheckboxProps()}
        cursor="pointer"
        _checked={{ color: "#6C56FB" }}
      >
        {text}
      </Box>
    </Box>
  );
};

const Post_Job = () => {
  const levels = [
    "Foundation",
    "3D NFT Creator",
    "3D Environment Creator",
    "XR Interaction Creator",
    "Simulation Creator",
    "Ajna Creator",
  ];
  const [jobDescription, setJobDescription] = useState("");

  const modules = {
    toolbar: [
      ["bold", "italic", "underline", "strike", "blockquote"],
      [{ align: ["center", "right", "justify"] }],
      [{ size: ["normal", "large", "huge"] }],
      [{ list: "ordered" }, { list: "bullet" }],
      // ['link', 'image', 'video'],
    ],
  };
  const formats = [
    "bold",
    "vertical",
    "italic",
    "underline",
    "strike",
    "blockquote",
    "list",
    "bullet",
    "align",
    "size",
  ];
  const [postData, setPostData] = useState({
    jobDescription: "",
    jobRoleTitle: "",
    jobType: "fullTime",
    location: "",
    packageOffered: "",
    sector: "",
    openings: "",
    applyByDate: "",
    requiredLevel: "",
    platform: "",
  });

  // useEffect(() => {
  //   console.log(postData);
  // }, [postData]);

  const [sectors, setSectors] = useState([]);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const location = useLocation();
  const locationEndpoint = location?.pathname?.split("/");
  // console.log({ levels: postData.requiredLevel });

  useEffect(() => {
    const getPost = async () => {
      if (locationEndpoint.length === 5) {
        const post = await api.getJobById(locationEndpoint[4]);
        const responseData = post.data.data;
        setPostData(post.data.data);
        setJobDescription(post.data.data.jobDescription);
        if (responseData.jobType) {
          setValue(responseData.jobType);
        }
        if (responseData.applyByDate) {
          setPostData((state) => ({
            ...state,
            applyByDate: moment(new Date(responseData.applyByDate)).format(
              "YYYY-MM-DD"
            ),
          }));
        }
        // console.log(responseData.applyByDate);
      }
    };
    const getSectors = async () => {
      const sectorsList = await api.getCreateHiringPostData();
      setSectors(sectorsList.data.data.data);
    };
    getPost();
    getSectors();
  }, []);
  const changeHandler = (e) => {
    if (e.target.name === "applyByDate") {
      setPostData((state) => ({
        ...state,
        applyByDate: moment(new Date(e.target.value)).format("YYYY-MM-DD"),
      }));
      return;
    } else {
      setPostData((state) => ({
        ...state,
        [e.target.name]: e.target.value,
      }));
    }
    // console.log(e.target.value);

    // console.log(e.target);
    console.log(postData);
  };
  const radioChangeHandler = (e) => {
    setPostData((state) => ({
      ...state,
      jobType: e,
    }));
  };
  const {
    value: radioValue,
    getRadioProps,
    setValue,
  } = useRadioGroup({
    name: "jobType",
    defaultValue: "fullTime",
    onChange: radioChangeHandler,
  });
  const saveDraftHandler = async () => {
    const data = {};
    for (const item in postData) {
      if (postData[item] !== "") {
        data[item] = postData[item];
      }
    }
    if (postData.jobRoleTitle != "" && postData.sector != "") {
      await api.savePostInDraft({ ...data, jobDescription: jobDescription });
      swAlert.fire({
        icon: "success",
        title: "Job Saved in Drafts",
        timer: 2000,
      });
      navigate("/hiring/recruiter/draft");
    } else {
      // swAlert.fire("Job role title and sector can't be empty...");
      swAlert.fire({
        icon: "warning",
        text: "Job role title and sector can't be empty...",
        timer: 1300,
      });
    }
  };
  const closeHandler = () => {
    navigate(-1);
  };

  // console.log({ jobDescription });

  const postJobHandler = async () => {
    const ctc = parseInt(postData.packageOffered);
    if (ctc < 6) {
      return swAlert.fire({
        icon: "warning",
        text: "CTC should be more than 6LPA",
        timer: 1300,
      });
    }
    const checkHTMLContent = (str) => {
      const doc = new DOMParser().parseFromString(str, "text/html");
      return [...doc.body.textContent].length > 0;
    };
    if (
      postData.jobRoleTitle != "" &&
      checkHTMLContent(jobDescription) &&
      postData.location != "" &&
      postData.packageOffered != "" &&
      postData.sector != "" &&
      postData.openings != "" &&
      postData.applyByDate != "" &&
      postData.requiredLevel != "" &&
      postData.platform !== ""
    ) {
      if (locationEndpoint.length === 5) {
        await api.savePostInDraft(postData);
        await api.changeJobStatus("active", locationEndpoint[4]);
      } else {
        try {
          const result = await api.createHiringPost({
            ...postData,
            jobDescription,
          });
        } catch (err) {
          if (
            err.response.data.message ===
            "This Job is already posted by your company."
          ) {
            swAlert.fire({
              icon: "error",
              title: "This Job is already posted by your company.",
              timer: 2000,
            });
          } else {
            swAlert.fire({
              icon: "error",
              title: "OOPS! Something went wrong...",
              timer: 2000,
            });
          }
          return;
        }
      }

      // {Note}
      // If we want to send recruiter to search tab and filter students after posting job we will uncomment below filter dispatch
      // dispatch(filterActions.setFilter(postData.requiredLevel));
      swAlert.fire({
        icon: "success",
        title: "Job Post Created",
        timer: 1300,
      });
      navigate("/hiring/recruiter/active");
      // swAlert.fire("Job created succesfully..");
    } else {
      // console.log(postData);
      // swAlert.fire("Please fill the required fields");
      swAlert.fire({
        icon: "warning",
        text: "Please fill the required fields",
        timer: 1300,
      });
    }
  };
  const formatDate = (date) => {
    const d = new Date(date);
    return `${d.getDate()}-${d.getMonth()}-${d.getFullYear()}`;
  };

  return (
    <div>
      <Navbar />
      <Box>
        <Center
          mt={[10, 10, 24, 24]}
          m={"auto"}
          w={["100%", "100%", "fit-content", "fit-content"]}
        >
          <Box
            border="1px solid #E7E6E8"
            boxShadow={"0px 4px 18px rgba(0, 0, 0, 0.13)"}
            h="auto"
            borderRadius="15px"
            mb={[0, 0, 20, 20]}
            pb={3}
            w={["100%", "100%", "", ""]}
          >
            {/* Heading */}
            <Center>
              <Flex
                justify="space-between"
                align="center"
                w={["90%", "90%", "95%", "95%"]}
              >
                <Box mt={8} w="95%">
                  <Heading
                    fontSize={["2xl", "2xl", "3xl", "3xl"]}
                    textAlign="left"
                    fontWeight={600}
                    fontFamily={"Epilogue"}
                  >
                    Create new job post
                  </Heading>
                </Box>
                <Flex align="center" mt={8}>
                  <CloseButton onClick={closeHandler} />
                </Flex>
              </Flex>
            </Center>

            {/* Form Fields */}
            <Flex display={["block", "block", "flex", "flex"]}>
              {/* First Half */}
              <Box h="80%" m={5} textAlign="left" py={2}>
                {/* Job Role box */}
                <Box>
                  <FormControl isRequired>
                    <FormLabel
                      fontSize={18}
                      fontWeight={500}
                      fontFamily={"Roboto"}
                      color="#848484"
                      ml={3}
                    >
                      Job role title
                    </FormLabel>
                    <Input
                      type="search"
                      name="jobRoleTitle"
                      fontFamily={"Roboto"}
                      placeholder="Type or Select"
                      borderRadius="12px"
                      list="jobRoles"
                      mt={2}
                      w={["100%", "100%", 450, 450]}
                      value={postData.jobRoleTitle}
                      onChange={changeHandler}
                      autoComplete="off"
                    />
                  </FormControl>
                  <datalist id="jobRoles">
                    <option>3D NFT Creator</option>
                    <option>3D Environment Creator</option>
                    <option>XR Interaction Creator</option>
                    <option>Simulation Creator</option>
                    <option>Digital Twin Creator</option>
                    <option>Ajna Creator</option>
                  </datalist>
                </Box>
                {/* Sector */}
                <Box mt={5}>
                  <FormControl isRequired>
                    <FormLabel
                      fontSize={18}
                      fontWeight={500}
                      fontFamily={"Roboto"}
                      color="#848484"
                      ml={3}
                    >
                      Sector
                    </FormLabel>
                    <Input
                      type="search"
                      name="sector"
                      fontFamily={"Roboto"}
                      placeholder="Type or Select"
                      borderRadius={12}
                      autoComplete="off"
                      list="sectors"
                      w={["100%", "100%", 450, 450]}
                      mt={2}
                      value={postData.sector}
                      onChange={changeHandler}
                    />
                  </FormControl>
                  <datalist id="sectors">
                    {sectors?.map((item, idx) => (
                      <option key={idx}>{item.name}</option>
                    ))}
                  </datalist>
                </Box>
                {/* Location */}
                <Box mt={5}>
                  <FormControl isRequired>
                    <FormLabel
                      fontSize={18}
                      fontWeight={500}
                      fontFamily={"Roboto"}
                      color="#848484"
                      ml={3}
                    >
                      Location
                    </FormLabel>
                    <Input
                      type="search"
                      name="location"
                      fontFamily={"Roboto"}
                      placeholder="Type or Search"
                      borderRadius="12px"
                      list="cities"
                      autoComplete="off"
                      w={["100%", "100%", 450, 450]}
                      mt={2}
                      value={postData.location}
                      onChange={changeHandler}
                    />
                  </FormControl>
                  <datalist id="cities">
                    <option>Mumbai</option>
                    <option>Bangalore</option>
                    <option>Chennai</option>
                    <option>Delhi</option>
                    <option>Pune</option>
                    <option>Kolkata</option>
                  </datalist>
                </Box>

                {/* Platform */}
                <Box mt={5}>
                  <FormControl isRequired>
                    <FormLabel
                      fontSize={18}
                      fontWeight={500}
                      fontFamily={"Roboto"}
                      color="#848484"
                      ml={3}
                    >
                      Platform
                    </FormLabel>
                  </FormControl>
                  <Select
                    fontFamily={"Roboto"}
                    color="#848484"
                    borderRadius={12}
                    name="platform"
                    onChange={changeHandler}
                    w={["100%", "100%", 250, 250]}
                  >
                    <option value="" hidden selected>
                      {postData?.platform
                        ? postData?.platform === "unity"
                          ? "Unity"
                          : "Unreal"
                        : "Select Platform"}
                    </option>
                    <option value="unity">Unity</option>
                    <option value="unreal">Unreal</option>
                  </Select>
                </Box>

                {/* Number of openings */}
                <Box mt={5}>
                  <FormControl isRequired>
                    <Flex
                      display={["block", "block", "flex", "flex"]}
                      justify="space-between"
                      align="center"
                      w={["100%", "100%", 450, 450]}
                    >
                      <FormLabel
                        fontSize={18}
                        fontWeight={500}
                        fontFamily={"Roboto"}
                        color="#848484"
                        ml={3}
                      >
                        Number of openings
                      </FormLabel>
                      <Input
                        name="openings"
                        w={["100%", "100%", 200, 200]}
                        fontFamily={"Roboto"}
                        type="number"
                        borderRadius="12px"
                        placeholder="Type here"
                        mt={2}
                        textAlign={["left", "left", "center", "center"]}
                        value={postData.openings}
                        onChange={changeHandler}
                      />
                    </Flex>
                  </FormControl>
                </Box>
                {/* Apply date */}
                <Box mt={5}>
                  <FormControl isRequired>
                    <Flex
                      display={["block", "block", "flex", "flex"]}
                      justify="space-between"
                      align="center"
                      w={["100%", "100%", 450, 450]}
                    >
                      <FormLabel
                        fontSize={18}
                        fontWeight={500}
                        fontFamily={"Roboto"}
                        color="#848484"
                        ml={3}
                      >
                        Apply by date :
                      </FormLabel>
                      <Input
                        w={["100%", "100%", 250, 250]}
                        type="date"
                        name="applyByDate"
                        fontFamily={"Roboto"}
                        borderRadius="12px"
                        placeholder="select date"
                        mt={2}
                        value={postData.applyByDate}
                        onChange={changeHandler}
                      />
                    </Flex>
                  </FormControl>
                </Box>
                {/* Levels */}
                <Box mt={5}>
                  <FormControl isRequired>
                    <Box>
                      <FormLabel
                        fontSize={18}
                        fontWeight={500}
                        fontFamily={"Roboto"}
                        color="#848484"
                        ml={3}
                      >
                        Required level
                      </FormLabel>
                      <Input
                        type="search"
                        name="requiredLevel"
                        placeholder="Type or Search"
                        borderRadius="12px"
                        list="levels"
                        fontFamily={"Roboto"}
                        autoComplete={"off"}
                        multiple
                        mt={2}
                        w={["100%", "100%", 450, 450]}
                        value={levels[postData.requiredLevel]}
                        onChange={changeHandler}
                      />
                      <datalist id="levels" bg="tomato">
                        {levels.map((item, idx) => (
                          <option value={idx}>{item}</option>
                        ))}
                      </datalist>
                    </Box>
                  </FormControl>
                </Box>
              </Box>
              {/* Seconf Half */}
              <Box h="80%" m={5} textAlign="left" py={2}>
                {/* Offered CTC */}
                <FormControl isRequired>
                  <Box>
                    <FormLabel
                      fontSize={18}
                      fontWeight={500}
                      fontFamily={"Roboto"}
                      color="#848484"
                      ml={3}
                    >
                      Offered Annual CTC
                    </FormLabel>
                    <Input
                      type="Number"
                      name="packageOffered"
                      placeholder="Add CTC in LPA (eg. 6)"
                      borderRadius="12px"
                      fontFamily={"Roboto"}
                      mt={2}
                      min={6}
                      step={5}
                      w={["100%", "100%", 450, 450]}
                      value={postData.packageOffered}
                      onChange={changeHandler}
                    />
                  </Box>
                </FormControl>
                {/* Job type */}
                <FormControl isRequired>
                  <Box mt={5}>
                    <FormLabel
                      fontSize={18}
                      fontWeight={500}
                      fontFamily={"Roboto"}
                      color="#848484"
                      ml={3}
                    >
                      Job Type
                    </FormLabel>
                    <Flex
                      border="1px solid #ECECEC"
                      h={10}
                      justify="center"
                      borderRadius={12}
                    >
                      <Center>
                        <RadioGroup>
                          <Stack
                            fontFamily={"Roboto"}
                            spacing={8}
                            direction="row"
                          >
                            {[
                              { name: "Full Time", value: "fullTime" },
                              { name: "Part Time", value: "partTime" },
                              { name: "Freelance", value: "wfh" },
                            ].map((item) => (
                              <CustomRadio
                                key={item.value}
                                text={item.name}
                                {...getRadioProps({ value: item.value })}
                              />
                            ))}
                          </Stack>
                        </RadioGroup>
                      </Center>
                    </Flex>
                  </Box>
                </FormControl>
                {/* Description */}

                <Box w={["100%", "100%", 450, 450]} mt={5}>
                  <FormControl isRequired>
                    <FormLabel
                      fontSize={18}
                      fontFamily={"Roboto"}
                      fontWeight={500}
                      color="#848484"
                      ml={3}
                    >
                      Job Description
                    </FormLabel>
                  </FormControl>
                  {/* <Textarea
                      name='jobDescription'
                      fontFamily={'Roboto'}
                      bg='#F9F9F9'
                      h={[200, 200, 288, 288]}
                      w={['100%', '100%', 450, 450]}
                      placeholder='Write Job Discription here...'
                      _placeholder={{ color: '#AFAFAF' }}
                      mt={2}
                      borderRadius={12}
                      value={postData.jobDescription}
                      onChange={changeHandler}
                    /> */}
                  {/* <Flex
                      border={"1px solid #ECECEC"}
                      h={384}
                      overflow="hidden"
                      borderRadius={12}
                    > */}
                  {postData?.jobDescription?.length === 0 && (
                    <ReactQuill
                      theme="snow"
                      width="100%"
                      modules={modules}
                      style={{
                        width: "100%",
                        height: "338px",
                        fontSize: "18px",
                        fontFamily: "Roboto",
                      }}
                      id="description_id"
                      formats={formats}
                      defaultValue={postData.jobDescription}
                      placeholder={"Write Job Discription here..."}
                      onChange={(content, delta, source, editor) => {
                        setJobDescription(editor.getHTML());
                      }}
                    />
                  )}
                  {postData?.jobDescription?.length !== 0 && (
                    <ReactQuill
                      theme="snow"
                      width="100%"
                      modules={modules}
                      style={{
                        width: "100%",
                        height: "338px",
                        fontSize: "18px",
                        fontFamily: "Roboto",
                      }}
                      id="description_id"
                      formats={formats}
                      defaultValue={postData.jobDescription}
                      // value={postData.jobDescription}
                      placeholder={"Write Job Discription here..."}
                      onChange={(content, delta, source, editor) => {
                        setJobDescription(editor.getHTML());
                      }}
                    />
                  )}

                  {/* </Flex> */}
                </Box>
              </Box>
            </Flex>
            {/* Buttons */}
            <Box
              mt={[20, 20, 0, 0]}
              px={5}
              py={1}
              w={["100%", "100%", "100%", "100%"]}
            >
              <Flex
                justify="right"
                align={["center", "center", "", ""]}
                gap={5}
                flexDir={["column", "column", "row", "row"]}
              >
                {/* Save as Draft */}
                <Flex
                  w={["95%", "95%", 150, 150]}
                  justify="center"
                  align="center"
                  border="1px solid #E7E6E8"
                  color="#000000"
                  h={10}
                  fontSize={18}
                  fontWeight={500}
                  fontFamily={"Roboto"}
                  borderRadius={12}
                  letterSpacing={"0.04em"}
                  py={1}
                  cursor="pointer"
                  onClick={saveDraftHandler}
                >
                  <Text textAlign="center">Save as Draft</Text>
                </Flex>
                {/* Close Button */}
                {/* <Flex
                  w={["95%", "95%", 150, 150]}
                  justify="center"
                  align="center"
                  border="1px solid #E7E6E8"
                  color="#000000"
                  h={10}
                  fontSize={18}
                  fontWeight={500}
                  fontFamily={"Roboto"}
                  letterSpacing={"0.04em"}
                  borderRadius={12}
                  py={1}
                  cursor="pointer"
                  onClick={closeHandler}
                >
                  <Text textAlign="center">Close</Text>
                </Flex> */}
                {/* Post Job Button */}
                <Flex
                  w={["95%", "95%", 150, 150]}
                  justify="center"
                  align="center"
                  bg="#6C56FB"
                  color="#FFFFFF"
                  h={10}
                  fontSize={18}
                  fontWeight={500}
                  fontFamily={"Roboto"}
                  letterSpacing={"0.04em"}
                  borderRadius={12}
                  py={1}
                  cursor="pointer"
                  onClick={postJobHandler}
                  _hover={{
                    boxShadow: "0px 8px 24px rgba(108, 86, 251, 0.2)",
                  }}
                >
                  <Text textAlign="center" alignItems="center">
                    Post Job
                  </Text>
                </Flex>
              </Flex>
            </Box>
          </Box>
        </Center>
      </Box>
    </div>
  );
};

export default Post_Job;
